import styled from 'styled-components';

import StyledDefaultVariant from './StyledDefaultVariant';

export default styled(StyledDefaultVariant)`
	flex-direction: column-reverse;
	align-items: start;
`;
